var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGridSpecific = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3335 12C5.78121 12 5.3335 12.4477 5.3335 13V19C5.3335 19.5523 5.78121 20 6.3335 20H13.6668C14.2191 20 14.6668 19.5523 14.6668 19V13C14.6668 12.4477 14.2191 12 13.6668 12H6.3335ZM18.3335 12C17.7812 12 17.3335 12.4477 17.3335 13V19C17.3335 19.5523 17.7812 20 18.3335 20H25.6668C26.2191 20 26.6668 19.5523 26.6668 19V13C26.6668 12.4477 26.2191 12 25.6668 12H18.3335Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGridSpecific);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_grid_specific.1a6db6c74bc8d70ad6db848996b98650.svg";